import { render } from "./ModalTerms.vue?vue&type=template&id=5a711675&scoped=true"
import script from "./ModalTerms.vue?vue&type=script&lang=js"
export * from "./ModalTerms.vue?vue&type=script&lang=js"

import "./ModalTerms.vue?vue&type=style&index=0&id=5a711675&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a711675"]])

export default __exports__